import React, { Component } from 'react';
import HeaderLogo from './HeaderLogo';
import $ from 'jquery';
import { Link } from 'react-router-dom';

class Header extends Component {
	constructor(props){
	    super(props);
	}

	render() {
    return (
    	<header id="header">
        <div className="container">
          <div className="row align-center">
            <div className="col-6">
              <HeaderLogo />
            </div>
            <div className="col-6">
              <div className="header-right d-flex align-center justify-end">
                <p className="p16 p-color pr-3">Don’t have an account?</p> <Link className="btn btn-primary" to="/sign-up">Sign up</Link>
              </div>
            </div>
          </div>
        </div>
      </header>
    )
	}
}

export default Header;